import { Injectable } from '@angular/core';
import { OverlayService } from '../services/overlay.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class DecoratorOverlayService {
  private static service: OverlayService;

  public constructor(service: OverlayService) {
    DecoratorOverlayService.service = service;
  }

  public static getService(): OverlayService {
    if (!DecoratorOverlayService.service) {
      throw new Error('DecoratorService not initialized');
    }
    return DecoratorOverlayService.service;
  }
}

export function LoaderDecorator(): MethodDecorator {
  return function(target: Object, key: string | symbol, descriptor: any) {


    const originalMethod = descriptor.value;

    descriptor.value = function(...args: any[]) {
      const loadingService = DecoratorOverlayService.getService();
      loadingService.setOverlayLoading(true);
      return originalMethod.apply(this, args)
        .pipe(finalize(() => {
          loadingService.setOverlayLoading(false);
        }));
    };

    return descriptor;
  };
}
